import * as React from "react";
import { cn } from "./utils";

export interface FormBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: "specialty" | "anatomic" | "indication" | "prevalence" | "status" | "scoring" | "study-type" | "country";
    children: React.ReactNode;
}

const FormBadge = React.forwardRef<HTMLSpanElement, FormBadgeProps>(
    ({ className, variant = "specialty", children, ...props }, ref) => {
        const variantStyles = {
            specialty: "bg-blue-100 text-blue-800",
            anatomic: "bg-green-100 text-green-800",
            indication: "bg-purple-100 text-purple-800",
            prevalence: "bg-orange-100 text-orange-800",
            status: "bg-slate-100 text-slate-800",
            scoring: "bg-indigo-100 text-indigo-800",
            "study-type": "bg-purple-100 text-purple-800",
            country: "bg-gray-100 text-gray-800",
        };

        return (
            <span
                ref={ref}
                className={cn(
                    "inline-flex items-center px-2 py-1 rounded font-medium text-xs",
                    variantStyles[variant],
                    className
                )}
                {...props}
            >
                {children}
            </span>
        );
    }
);

FormBadge.displayName = "FormBadge";

export { FormBadge };
